import { Injectable } from '@angular/core';
import { HttpContext } from '@angular/common/http';
import { BASE_SKIP_ERROR_TOAST } from '../../core/constants/base-http-context-tokens';
import {
  BranchListItemResponse,
  CreatedResponse,
  EmptySuccessfulResponse,
  ImportUploadResponse,
  ListApiResponse,
  PspBranchCreateRequest,
  PspBranchResponse,
  PspBranchService,
  PspService,
  UserItemResponse,
} from '../../../api';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class BasePspBranchService {
  constructor(private readonly pspService: PspService, private readonly pspBranchService: PspBranchService) {}

  getPspBranches(orgId: number, active?: any): Observable<Array<BranchListItemResponse>> {
    return this.pspBranchService
      .getPspBranchListOfBranches({ psp: orgId, active })
      .pipe(map((response) => response.data));
  }

  setActiveBranchStatus(orgId: number, branchId: number): Observable<EmptySuccessfulResponse> {
    return this.pspBranchService.postPspBranchActivateBranch({ psp: orgId, branch: branchId });
  }

  setInactiveBranchStatus(orgId: number, branchId: number): Observable<EmptySuccessfulResponse> {
    return this.pspBranchService.deletePspBranchDeactivateBranch({ psp: orgId, branch: branchId });
  }

  createPspBranch(orgId: number, body: PspBranchCreateRequest): Observable<CreatedResponse> {
    return this.pspBranchService.postPspBranchCreate({ psp: orgId, body });
  }

  getPspBranchUsers(psp: number, branch: number): Observable<ListApiResponse & { data?: Array<UserItemResponse> }> {
    return this.pspBranchService.getPspsBranchUsersList({ psp, branch });
  }

  addUsersToBranch(branch: number, psp: number, users: Array<number>): Observable<EmptySuccessfulResponse> {
    return this.pspBranchService.patchPspBranchAddUsers({ psp, branch, body: { users } });
  }

  deleteUserFromBranch(psp: number, user: number, branch: number): Observable<EmptySuccessfulResponse> {
    return this.pspBranchService.deletePspBranchDeleteUser({ psp, user, branch });
  }

  updateUsersInBranch(branch: number, psp: number, users: Array<number>): Observable<EmptySuccessfulResponse> {
    return this.pspBranchService.putPspBranchUpdateUsers({ psp, branch, body: { users } });
  }

  getPspBranch(psp: number, branch: number): Observable<PspBranchResponse> {
    return this.pspBranchService.getPspBranchShow({ psp, branch }).pipe(map((response) => response.data));
  }

  sendIzsRequestInformation(psp: number, branch: number) {
    return this.pspBranchService.postPspBranchIzsRequestInformation({ psp, branch });
  }

  getBranchImportTemplate(psp: number): Observable<Blob> {
    return this.pspBranchService.getPspBranchImportTemplate({ psp });
  }

  uploadBranchImport(psp: number, file: File): Observable<ImportUploadResponse | undefined> {
    return this.pspBranchService
      .postPspBranchImportUpload({
        psp,
        body: { file },
        context: new HttpContext().set(BASE_SKIP_ERROR_TOAST, true),
      })
      .pipe(map((response) => response.data));
  }

  processBranchImport(psp: number, importId: string): Observable<void> {
    return this.pspBranchService.postPspBranchImportProcess({ psp, import: importId });
  }
}
